import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import './FX.css';

const FX = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const fxArticles = [
    {
      id: 1,
      category: 'DOLLAR',
      title: 'Dollar Slides to Six-Month Low on Fed Rate Cut Speculation',
      subtitle: 'US currency weakens across major pairs as markets price in earlier monetary easing',
      date: 'January 27, 2026',
      time: '30 minutes ago',
      image: 'https://images.unsplash.com/photo-1580519542036-c47de6196ba5?w=800&h=450&fit=crop',
      slug: 'dollar-slides-six-month-low'
    },
    {
      id: 2,
      category: 'EURO',
      title: 'Euro Surges Past 1.20 as ECB Maintains Hawkish Stance',
      subtitle: 'Single currency reaches 18-month high against dollar on diverging policy expectations',
      date: 'January 27, 2026',
      time: '2 hours ago',
      image: 'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=800&h=450&fit=crop',
      slug: 'euro-surges-past-120'
    },
    {
      id: 3,
      category: 'EMERGING MARKETS',
      title: 'Asian Currencies Rally as Capital Flows Return to Region',
      subtitle: 'Thai baht and Indonesian rupiah lead gains amid risk-on sentiment',
      date: 'January 26, 2026',
      time: '1 day ago',
      image: 'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=800&h=450&fit=crop',
      slug: 'asian-currencies-rally'
    },
    {
      id: 4,
      category: 'YEN',
      title: 'Japanese Yen Strengthens as BOJ Signals Policy Normalization',
      subtitle: 'Currency hits strongest level since 2024 on expectations of further rate hikes',
      time: '1 day ago',
      image: 'https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?w=800&h=450&fit=crop',
      slug: 'yen-strengthens-boj-policy'
    }
  ];

  // FX News List - Left Column
  const fxListLeft = [
    { id: 1, title: 'Dollar Index Falls to Fresh 12-Month Low on Fed Dovish Signals', time: '30 minutes ago', image: 'https://images.unsplash.com/photo-1580519542036-c47de6196ba5?w=50&h=50&fit=crop', slug: 'dollar-index-12-month-low' },
    { id: 2, title: 'Euro-Dollar Breaks 1.22 Barrier as ECB Holds Rates Steady', time: '1 hour ago', image: 'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=50&h=50&fit=crop', slug: 'euro-dollar-breaks-122' },
    { id: 3, title: 'British Pound Gains 2.1% on Positive UK Inflation Data', time: '2 hours ago', image: 'https://images.unsplash.com/photo-1526304640581-d334cdbbf45e?w=50&h=50&fit=crop', slug: 'pound-gains-inflation-data' },
    { id: 4, title: 'Japanese Yen Touches 140 vs Dollar Amid BOJ Policy Shift', time: '3 hours ago', image: 'https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?w=50&h=50&fit=crop', slug: 'yen-140-boj-policy-shift' },
    { id: 5, title: 'Swiss Franc Surges as Safe-Haven Flows Return', time: '4 hours ago', image: 'https://images.unsplash.com/photo-1580519542036-c47de6196ba5?w=50&h=50&fit=crop', slug: 'swiss-franc-safe-haven-flows' },
    { id: 11, title: 'Australian Dollar Rallies on Strong Jobs Report', time: '5 hours ago', image: 'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=50&h=50&fit=crop', slug: 'aussie-dollar-jobs-report' },
    { id: 12, title: 'Canadian Dollar Extends Gains as Oil Prices Climb', time: '6 hours ago', image: 'https://images.unsplash.com/photo-1579621970563-ebec7560ff3e?w=50&h=50&fit=crop', slug: 'canadian-dollar-oil-prices' },
    { id: 13, title: 'Emerging Market Currencies Lead Gains Against Dollar', time: '7 hours ago', image: 'https://images.unsplash.com/photo-1526304640581-d334cdbbf45e?w=50&h=50&fit=crop', slug: 'emerging-currencies-lead-gains' },
    { id: 14, title: 'Chinese Yuan Strengthens to 6.85 Per Dollar', time: '8 hours ago', image: 'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=50&h=50&fit=crop', slug: 'chinese-yuan-strengthens' },
    { id: 15, title: 'New Zealand Dollar Hits 8-Month High on RBNZ Hawkish Tone', time: '9 hours ago', image: 'https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?w=50&h=50&fit=crop', slug: 'nz-dollar-8-month-high' }
  ];

  // FX News List - Right Column
  const fxListRight = [
    { id: 6, title: 'Currency Volatility Index Spikes to Three-Year High', time: '1 hour ago', image: 'https://images.unsplash.com/photo-1590283603385-17ffb3a7f29f?w=50&h=50&fit=crop', slug: 'currency-volatility-spikes' },
    { id: 7, title: 'Mexican Peso Rallies on Strong Remittance Flows', time: '2 hours ago', image: 'https://images.unsplash.com/photo-1580519542036-c47de6196ba5?w=50&h=50&fit=crop', slug: 'mexican-peso-remittance-flows' },
    { id: 8, title: 'Swedish Krona Weakens as Riksbank Cuts Rates', time: '3 hours ago', image: 'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=50&h=50&fit=crop', slug: 'swedish-krona-riksbank-cuts' },
    { id: 9, title: 'Indian Rupee Reaches Record Low Against Dollar', time: '4 hours ago', image: 'https://images.unsplash.com/photo-1526304640581-d334cdbbf45e?w=50&h=50&fit=crop', slug: 'rupee-record-low' },
    { id: 10, title: 'Turkish Lira Stabilizes After Central Bank Intervention', time: '5 hours ago', image: 'https://images.unsplash.com/photo-1579621970563-ebec7560ff3e?w=50&h=50&fit=crop', slug: 'turkish-lira-stabilizes' },
    { id: 16, title: 'South Korean Won Benefits from Tech Export Surge', time: '6 hours ago', image: 'https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?w=50&h=50&fit=crop', slug: 'korean-won-tech-exports' },
    { id: 17, title: 'Brazilian Real Climbs on Commodity Price Rally', time: '7 hours ago', image: 'https://images.unsplash.com/photo-1580519542036-c47de6196ba5?w=50&h=50&fit=crop', slug: 'brazilian-real-commodity-rally' },
    { id: 18, title: 'Singapore Dollar Reaches 5-Year High Against Dollar', time: '8 hours ago', image: 'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=50&h=50&fit=crop', slug: 'singapore-dollar-5-year-high' },
    { id: 19, title: 'Norwegian Krone Gains on Energy Price Strength', time: '9 hours ago', image: 'https://images.unsplash.com/photo-1526304640581-d334cdbbf45e?w=50&h=50&fit=crop', slug: 'norwegian-krone-energy-prices' },
    { id: 20, title: 'Hong Kong Dollar Peg Holds Steady Amid Market Volatility', time: '10 hours ago', image: 'https://images.unsplash.com/photo-1579621970563-ebec7560ff3e?w=50&h=50&fit=crop', slug: 'hk-dollar-peg-steady' }
  ];

  return (
    <>
      <Helmet>
        <title>FX News & Analysis - Foreign Exchange Markets | Redbox Global</title>
        <meta name="description" content="Latest foreign exchange news, currency market analysis, and FX trading insights. Coverage of major currency pairs, emerging market currencies, and central bank policies." />
        <meta name="keywords" content="FX, forex, foreign exchange, currency markets, dollar, euro, yen, pound, emerging market currencies, currency trading, exchange rates" />
        
        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content="FX News & Analysis - Redbox Global" />
        <meta property="og:description" content="Latest foreign exchange news, currency market analysis, and comprehensive FX trading insights from Redbox Global." />
        <meta property="og:url" content="https://redboxglobal.com/markets/fx" />
        <meta property="og:image" content="https://images.unsplash.com/photo-1580519542036-c47de6196ba5?w=1200&h=630&fit=crop" />
        
        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="FX News & Analysis - Redbox Global" />
        <meta name="twitter:description" content="Latest foreign exchange news, currency market analysis, and comprehensive FX trading insights." />
        <meta name="twitter:image" content="https://images.unsplash.com/photo-1580519542036-c47de6196ba5?w=1200&h=630&fit=crop" />
        
        <link rel="canonical" href="https://redboxglobal.com/markets/fx" />
      </Helmet>

      <div className="fx-page">
        <div className="container">
          {/* Breadcrumb */}
          <nav className="breadcrumb">
            <Link to="/">Home</Link>
            <span className="separator">/</span>
            <Link to="/markets">Markets</Link>
            <span className="separator">/</span>
            <span className="current">FX</span>
          </nav>

          {/* Page Header */}
          <header className="page-header">
            <h1 className="page-title">FX</h1>
            <p className="page-description">
              Real-time foreign exchange news, currency market analysis, and insights into global FX trading and central bank policies.
            </p>
          </header>

          {/* Featured Swiper Slider */}
          <section className="featured-section">
            <Swiper
              modules={[Autoplay, Pagination]}
              autoplay={{ delay: 5000, disableOnInteraction: false }}
              pagination={{ clickable: true }}
              loop
              className="fx-swiper"
            >
              {fxArticles.map((article) => (
                <SwiperSlide key={article.id}>
                  <article className="featured-article">
                    <Link to={`/article/${article.slug}`} className="featured-link">
                      <div className="featured-image">
                        <img src={article.image} alt={article.title} />
                        <span className="featured-category">{article.category}</span>
                      </div>
                    </Link>
                    <div className="featured-content">
                      <h2 className="featured-title">
                        <Link to={`/article/${article.slug}`}>{article.title}</Link>
                      </h2>
                      <p className="featured-subtitle">{article.subtitle}</p>
                      <div className="article-meta">
                        <span className="date">{article.time}</span>
                      </div>
                    </div>
                  </article>
                </SwiperSlide>
              ))}
            </Swiper>
          </section>

          {/* Bloomberg-style Two Column List */}
          <section className="bloomberg-two-columns">
            <div className="bloomberg-column">
              {fxListLeft.map((item) => (
                <article key={item.id} className="bloomberg-item">
                  <Link to={`/article/${item.slug}`} className="bloomberg-link">
                    <div className="bloomberg-thumb">
                      <img src={item.image} alt={item.title} />
                    </div>
                    <div className="bloomberg-text">
                      <h3 className="bloomberg-title">{item.title}</h3>
                      <span className="bloomberg-time">{item.time}</span>
                    </div>
                  </Link>
                </article>
              ))}
            </div>
            
            <div className="bloomberg-column">
              {fxListRight.map((item) => (
                <article key={item.id} className="bloomberg-item">
                  <Link to={`/article/${item.slug}`} className="bloomberg-link">
                    <div className="bloomberg-thumb">
                      <img src={item.image} alt={item.title} />
                    </div>
                    <div className="bloomberg-text">
                      <h3 className="bloomberg-title">{item.title}</h3>
                      <span className="bloomberg-time">{item.time}</span>
                    </div>
                  </Link>
                </article>
              ))}
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default FX;
